import HelpContent from "../../components/common/helpContent";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useState, useEffect } from "react";

const HelpPage = () => {
    // Animation states
    const [animationStates, setAnimationStates] = useState({
        header: false,
        content: false
    });

    // Trigger staggered animations on component mount
    useEffect(() => {
        const timeouts = [];

        // Stagger the animations with delays
        timeouts.push(setTimeout(() => {
            setAnimationStates(prev => ({ ...prev, header: true }));
        }, 100));

        timeouts.push(setTimeout(() => {
            setAnimationStates(prev => ({ ...prev, content: true }));
        }, 300));

        // Cleanup timeouts on unmount
        return () => {
            timeouts.forEach(timeout => clearTimeout(timeout));
        };
    }, []);

    return (
        <div className="responsive-page-layout scrollable">
            <div className={`help-title flex flex-col sm:flex-row justify-between items-start sm:items-center w-full transition-all duration-700 ease-out ${
                animationStates.header
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-4'
            }`}>
                <div className="flex flex-col sm:flex-row gap-2 items-start w-full lg:w-auto">
                    <div className="header-textbox">
                        <Icon icon="material-symbols:help-outline-rounded" className="header-icon"></Icon>
                        Help & FAQs
                    </div>
                </div>
                <button className="flex flex-row gap-1 items-center text-sm sm:text-base p-2 button-container text-font-primary rounded-md w-full md:w-fit">
                    <Icon icon="hugeicons:google-doc" className="text-lg sm:text-xl text-accent"></Icon>
                    <p className="whitespace-nowrap">Docs & Support</p>
                </button>
            </div>
            <div className={`w-full transition-all duration-700 ease-out ${
                animationStates.content
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-4'
            }`}>
                <HelpContent />
            </div>
        </div>
    );
};

export default HelpPage;